import React from "react";
import { AdminQuestionnaireResponsesView } from "./view";
import { styles } from "./styles";

export const AdminQuestionnaireResponses = props => (
  <AdminQuestionnaireResponsesView {...props} styles={styles} />
);
